export const GITHUB_URL = 'https://github.com/WorldOfTech0/WOT';
export const WEBSITE_URL = 'https://worldoftech.co.in';
export const TWITTER_URL = '#';
